module.exports = __webpack_public_path__ + "static/media/channels.9620f703.svg";